import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { CoverNodeView } from "@/components/editor/nodeviews/CoverNodeView";

export const CoverBlock = Node.create({
  name: "coverBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      src: { default: "" },
      title: { default: "" },
      subtitle: { default: "" },
      author: { default: "" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="cover-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "cover-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(CoverNodeView);
  },
});
